/**
 * Loadable.js
 * Written by: Li Liu
 */
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import LoadingAnim from '../LoadingAnim';

export const Loadable = ({ ready, renderFunc }) => {
  const [showAnim, setShowAnim] = useState(false);
  const [persistAnim, setPersistAnim] = useState(false);
  const activateTimer = useRef(false);
  const persistTimer = useRef(false);

  const startTimers = () => {
    activateTimer.current = setTimeout(() => {
      setShowAnim(true);
      setPersistAnim(true);
      persistTimer.current = setTimeout(() => {
        setPersistAnim(false);
      }, 1500);
    }, 500);
  };

  const clearTimers = () => {
    clearTimeout(activateTimer.current);
    clearTimeout(persistTimer.current);
  };

  const reset = () => {
    setShowAnim(false);
    setPersistAnim(false);
    clearTimers();
    startTimers();
  };

  useEffect(() => {
    // Start the timer to set showAnim to true
    startTimers();
    // Clear timers when unmount
    return (() => {
      clearTimers();
    });
  }, []);

  useEffect(() => {
    if (!ready && !persistAnim) {
      reset();
    }

    if (ready && !persistAnim) {
      clearTimers();
      setShowAnim(false);
      setPersistAnim(false);
    }
  }, [renderFunc, ready]);

  if (ready && !persistAnim) {
    return renderFunc();
  }

  return (
    showAnim
      ? <LoadingAnim />
      : null
  );
};

Loadable.propTypes = {
  renderFunc: PropTypes.func,
  ready: PropTypes.bool,
};

export default Loadable;
